import script from "./HomeVideoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeVideoComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeVideoComponent.vue?vue&type=style&index=0&id=5bd453bb&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd453bb"]])

export default __exports__